// extracted by mini-css-extract-plugin
export default {"scroll":"left_scroll__Azbie","drower":"left_drower__Crhqz"};